import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayjs from 'dayjs';
import { toAppointmentEvent } from '../toAppointmentEvent';
import { toBlockEvent } from '../agendaBlock/toBlockEvent';

function RoomDayColumn({ room, date, appointments, agendaBlocks, onEventClick, onDateClick }) {
  const events = useMemo(
    () => [...appointments.map(toAppointmentEvent), ...agendaBlocks.map(toBlockEvent)],
    [appointments, agendaBlocks],
  );

  return (
    <Box
      sx={{
        flex: '0 0 auto',
        width: 280,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{
          textAlign: 'center',
          py: 1,
          px: 1,
          bgcolor: 'action.hover',
          borderBottom: '1px solid',
          borderColor: 'divider',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {room.name}
      </Typography>
      <FullCalendar
        plugins={[timeGridPlugin, interactionPlugin]}
        initialView="timeGridDay"
        initialDate={dayjs(date).toDate()}
        locale="pt-br"
        nowIndicator
        editable={false}
        headerToolbar={false}
        allDaySlot={false}
        slotMinTime="06:00:00"
        slotMaxTime="21:00:00"
        contentHeight="auto"
        events={events}
        eventClick={onEventClick}
        dateClick={(event) => onDateClick(event, room.id)}
      />
    </Box>
  );
}

RoomDayColumn.propTypes = {
  room: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
  }).isRequired,
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Date), PropTypes.string])
    .isRequired,
  appointments: PropTypes.arrayOf(PropTypes.object),
  agendaBlocks: PropTypes.arrayOf(PropTypes.object),
  onEventClick: PropTypes.func.isRequired,
  onDateClick: PropTypes.func.isRequired,
};

RoomDayColumn.defaultProps = {
  appointments: [],
  agendaBlocks: [],
};

export default RoomDayColumn;
